import React, {Component} from 'react'
import {Link} from 'react-router'
import {language,pageOption} from "../utils/common";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import bumpService from 'SERVICES/purifier/bump/bumpService'
import ModalDel from "../component/ModalDel";
import Tip from "../component/tip";
import LongSearchInput from "../component/search/longSearchInput";
import {timesTampsToData} from "../function";
/**
 * Created by slf on 2017/7/27.
 */
export default class OtaIndex extends Component {
    constructor(props) {
        super(props);
        this.delList = this.delList;
        this.del = this.del.bind(this);
        this.state={
            list: [],
            pageSize: 10,
            page: 1,
            total: 0,
            delId: '',
        }
    }

    componentDidMount() {
        this.onPageChange(this.state.page,this.state.pageSize);

    }
    handle(cell, row) {
        return <div>
            <a  className={row.number == "ella"?"hidden":"btn btn-danger btn-sm"} data-target="#delModal" data-toggle="modal"
                onClick={this.delList.bind(this,row.id)}>{language()['delete']}</a>
        </div>

    };
    delList(id, e) {
        this.setState({
            delId: id,
        })
    }

    del() {
        const id = this.state.delId;
        bumpService.deleteFirmware(id).then(body=>{
            if (body.code == 8001) {
                $("#success_msg").text(body.msg);
                $("#success_tip").removeClass("hidden");
                this.onPageChange(1,10);
                setTimeout(function() {
                    $("#success_tip").addClass("hidden");
                }, 3000);

            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }
    reset(){
        $("#search").val('');
        this.onPageChange(1,10)
    }
    search(){
        this.onPageChange(1,this.state.pageSize);
    }
    onPageChange(page, sizePerPage, e) {
        const json = {
            "page": page,
            "pageSize": sizePerPage,
            search : $.trim($("#search").val())
        };
        var data =JSON.stringify(json);

        bumpService.searchFirmwareList({data}).then(body=>{
            console.log(body)
            this.setState({
                list : body.content,
                total : body.totalElements,
                page: page,
                pageSize: sizePerPage,
            })
        })
    }
    gmtCreate(cell,row){
        return row.gmtCreate == null||undefined||''?'':timesTampsToData(row.gmtCreate);
    }
    render() {
        let options = pageOption(this.state.page,this.state.pageSize);
        options['onPageChange'] = this.onPageChange.bind(this);
        const create_url = "/ota/otaAdd";
        return <div>
            <section className="content-header " >
                <h1> {language()['OTAManagement']} <small>{language()['OTAList']}</small> </h1>
            </section>
            <section className="content" >
                <div className="box box-primary color-palette-box">
                    <div className="box-header with-border">
                        <i className="fa fa-list"></i>
                        <h3 className="box-title">{language()['OTAList']}</h3>
                        <div style={{marginRight:"10px",float:"right"}}>
                            <Link  to ={create_url} className="btn btn-success btn-md"  >
                                <i className="fa fa-plus-circle"></i> {language()['add']}
                            </Link>
                        </div>
                    </div>
                    <div className="box-body">
                        <Tip ids=""/>
                        <div className="title-box">

                        </div>
                        <div >
                            <BootstrapTable data = {this.state.list}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }}  striped hover pagination={true} options={options}  >
                                <TableHeaderColumn isKey dataField='id' hidden={true}>id </TableHeaderColumn>
                                <TableHeaderColumn dataField='name' width="150"> {language()['versionName']} </TableHeaderColumn>
                                <TableHeaderColumn  dataField='openId'  width="120">{language()['openID']}</TableHeaderColumn>
                                <TableHeaderColumn  dataField='productId'  width="120">{language()['productID']}</TableHeaderColumn>
                                <TableHeaderColumn  dataField='version'  width="150">{language()['versionNumber']}</TableHeaderColumn>
                                <TableHeaderColumn  dataField='type'  width="150">{language()['SoftwareType']}</TableHeaderColumn>
                                <TableHeaderColumn  dataField='gmtCreate' dataFormat={this.gmtCreate.bind(this)}  width="150">{language()['createTime']}</TableHeaderColumn>
                                <TableHeaderColumn  dataFormat={this.handle.bind(this)}  width="150" columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </section>
            <ModalDel delModSure={this.del} id="delModal"/>

        </div>
    }
}


// WEBPACK FOOTER //
// ./modules/ota/otaIndex.js